import rest from '@exchange/libs/utils/rest/src';

import DocumentResources from './document';

const URL = 'documents';

export enum BEDocumentType {
  CLIENT_FUNDS_REPORT = 'CLIENT_FUNDS_REPORT',
  EXECUTION_STATEMENT = 'EXECUTION_STATEMENT',
  LEVERAGED_TRANSACTION_NOTIFICATION = 'LEVERAGED_TRANSACTION_NOTIFICATION',
}

export interface BEDocument {
  date: string;
  filename: string;
  id: string;
  type: BEDocumentType;
}

interface BEDocumentsResponse {
  cursor?: string;
  documents: BEDocument[];
}

export default function DocumentsResources({ base }) {
  return {
    async get(documentTypes?: BEDocumentType[], fromDate?: string, toDate?: string, cursor?: string): Promise<BEDocumentsResponse> {
      const response = await rest.request(
        {
          method: 'post',
          payload: {
            ...(cursor && { cursor }),
            ...(documentTypes && { documentTypes }),
            ...(fromDate && { fromDate }),
            ...(toDate && { toDate }),
          },
          url: URL,
          base,
        },
        {
          useSubaccount: false,
        },
      );

      return response;
    },
    Document: (id: string) => DocumentResources({ base, documentURL: `${URL}/${id}` }),
  };
}
